(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stikkys-google-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stikkys-google-reviews')) {
    customElements.define('stikkys-google-reviews', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.controls = this.querySelector('[data-review-controls]');
        this.previousButton = this.querySelector('[data-review-previous]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.status = this.querySelector('[data-review-status]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.bindControls();
        this.prepareCards();
        this.updateControls();

        if (this.dataset.liveEnabled === 'true' && this.dataset.apiKey && this.dataset.placeId) {
          this.observe();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.stopAutoplay();
      }

      observe() {
        if (!('IntersectionObserver' in window)) {
          this.loadReviews();
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.loadReviews();
        }, { rootMargin: '320px 0px' });
        this.observer.observe(this);
      }

      bindControls() {
        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.track?.addEventListener('scroll', () => this.updateControls(), { passive: true });
        this.addEventListener('pointerenter', () => this.stopAutoplay());
        this.addEventListener('pointerleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        if (this.track) this.resizeObserver.observe(this.track);
      }

      move(direction) {
        const card = this.track?.querySelector('.stikkys-google-review');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const amount = card.getBoundingClientRect().width + gap;
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
        const atStart = this.track.scrollLeft <= 4;

        if (direction > 0 && atEnd) {
          this.track.scrollTo({ left: 0, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        } else if (direction < 0 && atStart) {
          this.track.scrollTo({ left: this.track.scrollWidth, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        } else {
          this.track.scrollBy({ left: amount * direction, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        }
      }

      updateControls() {
        if (!this.track || !this.controls) return;
        const canScroll = this.dataset.carousel === 'true' && this.track.scrollWidth > this.track.clientWidth + 4;
        this.controls.hidden = !canScroll;
        if (canScroll) this.startAutoplay();
      }

      startAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.reducedMotion || this.controls?.hidden || this.autoplayTimer) return;
        const delay = Number(this.dataset.autoplaySpeed || 7) * 1000;
        this.autoplayTimer = window.setInterval(() => this.move(1), delay);
      }

      stopAutoplay() {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      prepareCards() {
        this.querySelectorAll('.stikkys-google-review').forEach((card) => {
          const copy = card.querySelector('[data-review-copy]');
          const button = card.querySelector('[data-read-more]');
          if (!copy || !button) return;
          requestAnimationFrame(() => {
            button.hidden = copy.scrollHeight <= copy.clientHeight + 2;
          });
          button.addEventListener('click', () => {
            const expanded = copy.dataset.expanded === 'true';
            copy.dataset.expanded = String(!expanded);
            button.textContent = expanded ? this.dataset.readMoreLabel : this.dataset.readLessLabel;
            button.setAttribute('aria-expanded', String(!expanded));
          });
        });
      }

      async loadReviews() {
        this.status.textContent = 'Loading Google Maps reviews';
        try {
          await this.loadGoogleMaps();
          const { Place } = await google.maps.importLibrary('places');
          const place = new Place({ id: this.dataset.placeId });
          await place.fetchFields({ fields: ['displayName', 'rating', 'userRatingCount', 'reviews', 'googleMapsURI'] });
          const reviews = (place.reviews || []).slice(0, Number(this.dataset.maxReviews || 5));
          if (!reviews.length) throw new Error('No Google Maps reviews were returned');
          this.renderReviews(reviews, place);
          this.status.textContent = `${reviews.length} Google Maps reviews loaded`;
        } catch (error) {
          this.status.textContent = 'Google Maps reviews could not be loaded. The existing review summary remains available.';
        }
      }

      loadGoogleMaps() {
        if (window.google?.maps?.importLibrary) return Promise.resolve();
        if (window.stikkysGoogleMapsPromise) return window.stikkysGoogleMapsPromise;

        window.stikkysGoogleMapsPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(this.dataset.apiKey)}&loading=async&v=weekly`;
          script.async = true;
          script.onload = resolve;
          script.onerror = () => reject(new Error('Google Maps failed to load'));
          document.head.appendChild(script);
        });
        return window.stikkysGoogleMapsPromise;
      }

      renderReviews(reviews, place) {
        this.track.replaceChildren();
        reviews.forEach((review) => this.track.appendChild(this.createCard(review, place.googleMapsURI)));
        this.track.hidden = false;
        this.updateSummary(place);
        this.updateLinks(place.googleMapsURI);
        this.prepareCards();
        requestAnimationFrame(() => this.updateControls());
      }

      createCard(review, placeUrl) {
        const card = document.createElement('article');
        card.className = 'stikkys-google-review';
        card.setAttribute('role', 'listitem');

        const author = review.authorAttribution;
        const authorName = author?.displayName || 'Google Maps reviewer';
        card.setAttribute('aria-label', `Review from ${authorName}`);

        const stars = document.createElement('div');
        stars.className = 'stikkys-google-review__stars';
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', `${review.rating || 0} out of 5 stars`);
        for (let index = 1; index <= 5; index += 1) {
          const star = document.createElement('span');
          star.textContent = '★';
          star.setAttribute('aria-hidden', 'true');
          if (index > Math.round(review.rating || 0)) star.className = 'is-muted';
          stars.appendChild(star);
        }

        const copyWrap = document.createElement('div');
        copyWrap.className = 'stikkys-google-review__copy-wrap';
        const copy = document.createElement('p');
        copy.className = 'stikkys-google-review__copy';
        copy.dataset.reviewCopy = '';
        copy.style.setProperty('--review-lines', this.dataset.cardLines || 7);
        copy.textContent = review.text || '';
        const more = document.createElement('button');
        more.className = 'stikkys-google-review__more';
        more.type = 'button';
        more.dataset.readMore = '';
        more.textContent = this.dataset.readMoreLabel;
        more.hidden = true;
        copyWrap.append(copy, more);

        const footer = document.createElement('footer');
        footer.className = 'stikkys-google-review__footer';
        const authorWrap = document.createElement('div');
        authorWrap.className = 'stikkys-google-review__author';

        if (author?.photoURI) {
          const image = document.createElement('img');
          image.className = 'stikkys-google-review__avatar';
          image.src = author.photoURI;
          image.alt = authorName;
          image.width = 48;
          image.height = 48;
          image.loading = 'lazy';
          authorWrap.appendChild(image);
        } else {
          const initial = document.createElement('span');
          initial.className = 'stikkys-google-review__initial';
          initial.setAttribute('aria-hidden', 'true');
          initial.textContent = authorName.slice(0, 1).toUpperCase();
          authorWrap.appendChild(initial);
        }

        const authorCopy = document.createElement('span');
        authorCopy.className = 'stikkys-google-review__author-copy';
        const authorElement = document.createElement(author?.uri ? 'a' : 'strong');
        authorElement.textContent = authorName;
        if (author?.uri) {
          authorElement.href = author.uri;
          authorElement.target = '_blank';
          authorElement.rel = 'noopener noreferrer';
        }
        authorCopy.appendChild(authorElement);

        if (review.relativePublishTimeDescription) {
          const date = document.createElement('span');
          date.className = 'text-opacity';
          date.textContent = review.relativePublishTimeDescription;
          authorCopy.appendChild(date);
        }
        authorWrap.appendChild(authorCopy);
        footer.appendChild(authorWrap);

        const reviewUrl = review.googleMapsURI || placeUrl || this.dataset.googleUrl;
        if (reviewUrl) {
          const source = document.createElement('a');
          source.className = 'stikkys-google-review__source reversed-link';
          source.href = reviewUrl;
          source.target = '_blank';
          source.rel = 'noopener noreferrer';
          source.textContent = this.dataset.viewReviewLabel;
          footer.appendChild(source);
        }

        card.append(stars, copyWrap, footer);
        return card;
      }

      updateSummary(place) {
        const rating = this.querySelector('[data-overall-rating]');
        const count = this.querySelector('[data-overall-count]');
        const label = this.querySelector('[data-overall-rating-label]');
        const stars = this.querySelector('[data-overall-stars]');
        if (rating && typeof place.rating === 'number') rating.textContent = place.rating.toFixed(1);
        if (count && typeof place.userRatingCount === 'number') count.textContent = `Based on ${place.userRatingCount} Google reviews`;
        if (label && typeof place.rating === 'number') label.textContent = `Rated ${place.rating.toFixed(1)} out of 5 on Google Maps`;
        if (stars && typeof place.rating === 'number') {
          const roundedRating = Math.round(place.rating);
          stars.setAttribute('aria-label', `${place.rating.toFixed(1)} out of 5 stars`);
          stars.querySelectorAll('span').forEach((star, index) => {
            star.classList.toggle('is-muted', index + 1 > roundedRating);
          });
        }
      }

      updateLinks(url) {
        if (!url) return;
        this.querySelectorAll('[data-google-link]').forEach((link) => link.href = url);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
